<template>
  <!-- 预渲染使用 不要删除 app 的div-->
  <div id="app">
    <!-- <cpp /> -->
    <!-- <architect /> -->
    <!-- <media /> -->
    <newMedia2 />
  </div>
</template>

<script>
// import cpp from './pages/cpp'
// import architect from './pages/architect'
// import media from './pages/media'
import newMedia2 from './pages/newMedia2'
export default {
  name: 'App',
  components: {
    // cpp,
    // architect,
    // media,
    newMedia2
  },
  mounted() {
  },
  metaInfo: {
    title: '短视频培训_短视频运营培训_IP短视频带货线上训练营-传智教育',
    meta: [
      {
        name: 'Keywords',
        content: '短视频培训,短视频带货,短视频线上训练营,ip型短视频,传智教育'
      },
      {
        name: 'Description',
        content: '传智教育(“传智播客”全新升级为“传智教育”)短视频培训课程焕新升级V4.0版本——IP短视频带货线上训练营，对标抖音账号新玩法精准解锁推荐、搜索、付费三大流量密码，实现IP视频带货，学习成就超级副业的短视频核心技术！'
      }
    ]
  },
}
</script>

<style lang="scss">
body,
html {
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: 1;
  font-size: 14px;
  scroll-behavior: smooth;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
ul,
p,
span,
h1,
h2,
h3,
h4,
h5,
h6,
i,
div {
  margin: 0;
  padding: 0;
  list-style: none;
}
input {
  outline: none;
}

#chatBtn{display: none !important;}
</style>
